<template>
  <div>
    <section class="before-footer">
      <div class="container">
        <div
          class="row"
          v-if="paket"
        >
          <div
            class="col-md-6"
            v-for="p in paket"
            :key="p.id_paket"
          >
            <div
              class="item-hover card long-shadow"
              @click="$router.push({path: '/layanan/'+p.slug})"
            >
              <div
                class="card-body d-flex p-45"
                style="min-height: 230px"
              >
                <div class="card-icon text-white">
                  <img :src="$store.getters.getBaseUrl+'/api/file/'+p.icon">
                  <!-- <img :src="require('./../../assets/img/icon/computer.png')"> -->
                </div>
                <div class="w-100">
                  <h5>{{ p.nama_paket }}</h5>
                  <p class="lh-sm">
                    {{ p.deskripsi_paket }}
                  </p>
                  <p class="readmore">
                    <router-link
                      :to="'/layanan/'+p.slug"
                      class="link-icon"
                    >
                      Lihat Selengkapnya <i class="fas fa-chevron-right" />
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-else
        >
          <div
            class="col-md-6"
            v-for="p in 4"
            :key="p"
          >
            <div class="item-hover card long-shadow">
              <div
                class="card-body d-flex p-45"
                style="min-height: 230px"
              >
                <div class="card-icon text-white content-loader" />
                <div class="w-100">
                  <h5 class="content-loader">
                    Nama Paket
                  </h5>
                  <p class="lh-sm content-loader">
                    Deskripsi Paket
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
    .card-icon {
        width: 50px;
        height: 50px;
        border-radius: 3px;
        text-align: center;
        margin-right: 20px;
        flex-grow: 0;
        flex-shrink: 0;
    }
    .card-icon i {
        line-height: 50px;
        font-size: 20px;
    }
    .card .readmore {
        position:absolute;
        bottom:30px;
        right:30px
    }

    .card.item-hover {
        cursor: pointer;
        transition: all .5s;
    }
    .card.item-hover:hover {
        transform: scale(1.1);
    }
    
    @media (max-width: 575.98px){
        .before-footer {
            margin-top: -120px;
        }
    }
</style>

<script>
export default {
    data(){
        return {

        }
    },
    computed: {
        paket(){
            return this.$store.getters.getPaket
        }
    },
    created(){
        this.$store.dispatch('fetchPaketPublic')
    }
}
</script>